
    <span *ngIf="isLoading">Calculating...</span>
    <span *ngIf="!isLoading">{{salary}}</span>
  